import BooleanField from 'admin-config/lib/Field/BooleanField';
class BoolTimestampField extends BooleanField {
    constructor(name) {
        super(name);
        this._type = 'bool_timestamp';
        let ts = Date.parse(new Date()) / 1000;
        this._choices = [
            { value: ts, label: 'true' },
            { value: null, label: 'false' }
        ];
        this._filterChoices = [
            { value: ts, label: 'true' },
            { value: null, label: 'false' }
        ];
    }
    attributes() {
        return {value: Date.parse(new Date()) / 1000}
    }

    getLabelForChoice(value, entry) {
         let choices = typeof(this._choices) === 'function' ? this._choices(entry) : this._choices;
         let choice = choices.filter(c => Boolean(c.value) == Boolean(value)).pop();
        return choice ? choice.label : null;
    }
}
module.exports = BoolTimestampField;


// WEBPACK FOOTER //
// ./client/app/fields/bool_timestamp.js